(function (win) {
    "use strict";
    var listeners = [],
    doc = win.document,
    MutationObserver = win.MutationObserver || win.WebKitMutationObserver,
    observer;
    function ready(selector, fn) {
    // Store the selector and callback to be monitored
    listeners.push({
        selector: selector,
        fn: fn,
    });
    if (!observer) {
        // Watch for changes in the document
        observer = new MutationObserver(check);
        observer.observe(doc.documentElement, {
        childList: true,
        subtree: true,
        });
    }
    // Check if the element is currently in the DOM
    check();
    }
    function check() {
    // Check the DOM for elements matching a stored selector
    for (
        var i = 0, len = listeners.length, listener, elements;
        i < len;
        i++
    ) {
        listener = listeners[i];
        // Query for elements matching the specified selector
        elements = doc.querySelectorAll(listener.selector);

        for (var j = 0, jLen = elements.length, element; j < jLen; j++) {
        element = elements[j];
        // Make sure the callback isn't invoked with the
        // same element more than once
        if (!element.ready) {
            element.ready = "select";
            // Invoke the callback with the element
            listener.fn.call(element, element);
        }
        }
    }
    }
    win.eleReady = ready;
})(this);



/* Main Initialization Function */
function initEnhancements() {

    // Current page url
    const currentUrl = window.location.origin + window.location.pathname;
    
    // Prepend toolbar to collection container
    const toolbar = document.querySelector('.page-title-wrapper-lookbook');
    const collection = document.querySelector('.collection');
    if (toolbar && collection && !collection.contains(toolbar)) {
        collection.insertBefore(toolbar, collection.firstChild);
    }

    // Add class on page title wrapper
    const pageTitle = document.querySelector('.articleLookbook-title');
    if (pageTitle) {
        const pageTitleWrapper = pageTitle.closest('.articleLookbook-block');
        pageTitleWrapper?.classList.add('page-title-wrapper-lookbook');
    }

}
function handleResponsiveInit() {
    if (window.innerWidth < 768) {
      // Size filter and Availability label
      if (!document.querySelector('.filteritem-size') || !document.querySelector('.filteritem-availability')) {
          const sizeFilterHTML = `
                                  <div class="filter-item filteritem-size clearfix">
                                      <div class="filter-dropdown filter-size">
                                      <div class="filter-label hidden-on-desktop">
                                          <span class="filter-lbltext">Size</span>
                                      </div>
                                      </div>
                                  </div>
                                  <div class="filter-item filteritem-availability clearfix">
                                      <div class="filter-dropdown filter-availability">
                                      <div class="filter-label hidden-on-desktop">
                                          <span class="filter-lbltext">Availability</span>
                                      </div>
                                      </div>
                                  </div>
                              `;
        document.querySelector('.toolbar-wrapper:not(.toolbar-mobile) .toolbar-col.toolbar-colRight')?.insertAdjacentHTML('afterbegin', sizeFilterHTML);
        //document.querySelector('.toolbar-wrapper.toolbar-mobile')?.insertAdjacentHTML('afterbegin', sizeFilterHTML);
      }
  
      // Size filter popup
      if (!document.querySelector('.sizesfilter-dropdown-menu')) {
          const sizeFilterContentEl = document.querySelector('#CollectionFiltersForm .sidebarBlock.Size');
          if (sizeFilterContentEl) {
          const sizeFilterPopupHTML = `
              <div class="dropdown-menu sizesfilter-dropdown-menu hidden-on-desktop">
              <div class="dropdown-menu-header">
                  <h2 class="dropdown-menu-title"><span class="text">Size:</span></h2>
                  <div class="icon-wrapper">
                  <svg class="close-mobile-modal" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><g transform="translate(0,256) scale(0.1,-0.1)"><path d="M34 2526 c-38 -38 -44 -76 -18 -116 9 -14 265 -274 568 -577l551 -553 -551 -553c-303 -303 -559 -563 -568 -577 -26 -40 -20 -78 18 -116 38 -38 76 -44 116 -18 14 9 274 265 578 568l552 551 553 -551c303 -303 563 -559 577 -568 40 -26 78 -20 116 18 38 38 44 76 18 116 -9 14 -265 274 -568 578l-551 552 551 553c303 303 559 563 568 577 26 40 20 78 -18 116 -38 38 -76 44 -116 18 -14 -9 -274 -265 -577 -568l-553 -551 -552 551c-304 303 -564 559 -578 568 -40 26 -78 20 -116 -18z"></path></g></svg>
                  </div>
              </div>
              <div class="dropdown-menu-content">
                  ${sizeFilterContentEl.innerHTML}
              </div>
              </div>`;
          document.querySelector('toolbar-item.toolbar')?.insertAdjacentHTML('beforeend', sizeFilterPopupHTML);
          }
      }
  
      // Availability filter popup
      if (!document.querySelector('.availabilityfilter-dropdown-menu')) {
          const availabilityFilterContentEl = document.querySelector('#CollectionFiltersForm .sidebarBlock.Availability');
          if (availabilityFilterContentEl) {
            const availabilityFilterPopupHTML = `
                <div class="dropdown-menu availabilityfilter-dropdown-menu hidden-on-desktop">
                <div class="dropdown-menu-header">
                    <h2 class="dropdown-menu-title"><span class="text">Availability</span></h2>
                    <div class="icon-wrapper">
                    <svg class="close-mobile-modal" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256"><g transform="translate(0,256) scale(0.1,-0.1)"><path d="M34 2526 c-38 -38 -44 -76 -18 -116 9 -14 265 -274 568 -577l551 -553 -551 -553c-303 -303 -559 -563 -568 -577 -26 -40 -20 -78 18 -116 38 -38 76 -44 116 -18 14 9 274 265 578 568l552 551 553 -551c303 -303 563 -559 577 -568 40 -26 78 -20 116 18 38 38 44 76 18 116 -9 14 -265 274 -568 578l-551 552 551 553c303 303 559 563 568 577 26 40 20 78 -18 116 -38 38 -76 44 -116 18 -14 -9 -274 -265 -577 -568l-553 -551 -552 551c-304 303 -564 559 -578 568 -40 26 -78 20 -116 -18z"></path></g></svg>
                    </div>
                </div>
                <div class="dropdown-menu-content">
                    ${availabilityFilterContentEl.innerHTML}
                </div>
                </div>`;
            document.querySelector('toolbar-item.toolbar')?.insertAdjacentHTML('beforeend', availabilityFilterPopupHTML);
          }
      }
  
      /* Sort By
      const sortFilter = document.querySelector('.template-collection toolbar-item.toolbar .toolbar-item.toolbar-sort').cloneNode(true);
      document.querySelector('.toolbar-wrapper.toolbar-mobile')?.insertAdjacentHTML('beforeend', sortFilter);
      */
    }
}


/* Popup HTML for Quick View */
const popupHTML = `
    <div class="CP-quick-view-modal" style="display:none;">
        <div class="CP-modal-content">
        <span class="CP-close-btn">&times;</span>
        <div class="CP-product-media"></div>
        <div class="CP-product-title"></div>
        <div class="CP-product-price"></div>
        <div class="CP-product-info"></div>
        <div class="CP-view-details"><button class="CP-view-details-btn">View Details</button><div>
        </div>
    </div>
    `;
document.body.insertAdjacentHTML("beforeend", popupHTML);



/******************************************
        * Main Code Execution *
******************************************/
window.requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame || function (timeOutFn) {
  return setTimeout(timeOutFn, 1000 / 60);
};
window['CP_FESTIVE_THEME'] = function () {
  if (document.querySelector('body.template-collection') && !document.body.classList.contains('CP_FESTIVE_THEME')) {
        document.body.classList.add('CP_FESTIVE_THEME');


    // Add class filter wrapper to the mobile filter icon
    const mobileFilter = document.querySelector('.toolbar-icon.icon-filter');
    mobileFilter.closest('.toolbar-wrapper').classList.add('toolbar-filter-wrapper');
    
   
    // Call function to initialize enhancements
    initEnhancements();

    // Run once on DOM ready
    document.addEventListener('DOMContentLoaded', handleResponsiveInit);
    // Run on resize (with debounce to avoid performance issues)
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        handleResponsiveInit();
      }, 150);
    });


    const productGrid = document.querySelector(".productListing") || document.body;
    if (productGrid) {
        /* Add review elements to the product cards */
        //const reviewStarsHTML = `<div class="jdgm-rev-widg__summary-stars" aria-label="Average rating is 5.00 stars" role="img"><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-star jdgm--on"></span><span class="jdgm-rev-widg__summary-average">5.00 out of 5</span></div>`;

        eleReady('.productListing .card', (el) => {
            // Add review stars to each product card heading
            // const headings = el.querySelectorAll(".card__heading");
            // headings.forEach((heading) => {
            //     if (!heading.nextElementSibling?.classList.contains("jdgm-rev-widg__summary-stars")) {
            //         heading.insertAdjacentHTML("afterend", reviewStarsHTML);
            //     }
            // });
            // Add action buttons to each product card
            const cardInfo = el.querySelector(".card-information__wrapper");
            if (cardInfo && !cardInfo.querySelector(".CP-action-btn")) {
                const actionButtonHTML = `<div class="CP-action-btn"><button class="CP-quick-view-btn">Quick View</button><button class="CP-atc-btn">Add To Cart</button></div>`;
                cardInfo.insertAdjacentHTML("beforeend", actionButtonHTML);
            }
        });
    }

    // Delegated click handler for size filter toggle
    document.addEventListener('click', function (e) {
        const openBtn = e.target.closest('.filter-size');
        const closeBtn = e.target.closest('.sizesfilter-dropdown-menu .icon-wrapper');
        const filterItem = e.target.closest('.sizesfilter-dropdown-menu ul.facets-layout li.list-menu__item');

        if (openBtn) {
            document.body.classList.add('size-toolbar-modal-open');
            document.querySelector('.sizesfilter-dropdown-menu')?.classList.add('show-dropdownmenu');
          //
            document.body.classList.remove('availability-toolbar-modal-open');
            document.querySelector('.availabilityfilter-dropdown-menu').classList.remove('show-dropdownmenu');
          //
            document.documentElement.classList.remove('quick_shop_popup_mobile');
            document.querySelector('.quick_shop_option_2 #halo-card-mobile-popup.show').remove('show');
        }
        if (closeBtn) {
            document.body.classList.remove('size-toolbar-modal-open');
            document.querySelector('.sizesfilter-dropdown-menu')?.classList.remove('show-dropdownmenu');
        }
        if (filterItem) {
            document.body.classList.remove('size-toolbar-modal-open');
            document.querySelector('.sizesfilter-dropdown-menu')?.classList.remove('show-dropdownmenu');
        }
    });
    // Delegated click handler for availability filter toggle
    document.addEventListener('click', function (e) {
        const openBtn = e.target.closest('.filter-availability');
        const closeBtn = e.target.closest('.availabilityfilter-dropdown-menu .icon-wrapper');
        //const filterItem = e.target.closest('.availabilityfilter-dropdown-menu ul.facets-layout li.list-menu__item');

        if (openBtn) {
            document.body.classList.add('availability-toolbar-modal-open');
            document.querySelector('.availabilityfilter-dropdown-menu')?.classList.add('show-dropdownmenu');
          //
            document.documentElement.classList.remove('quick_shop_popup_mobile');
            document.querySelector('.quick_shop_option_2 #halo-card-mobile-popup.show').remove('show');
          //
            document.body.classList.remove('size-toolbar-modal-open');
            document.querySelector('.sizesfilter-dropdown-menu').classList.remove('show-dropdownmenu');
        }
        if (closeBtn) {
            document.body.classList.remove('availability-toolbar-modal-open');
            document.querySelector('.availabilityfilter-dropdown-menu')?.classList.remove('show-dropdownmenu');
        }
    });


    /*  
  function insertPromoBlocks() {
    const products = document.querySelectorAll('body.template-collection .collection .productListing .product');
    if (!products.length) return;
  
    // Remove previously inserted blocks
    document.querySelectorAll('.custom-promo-section').forEach(el => el.remove());
  
    Array.from(products).forEach((product, index) => {
      if ((index + 1) % 6 === 0) {
        const promo = document.createElement('li');
        promo.className = 'festive-promo-section';
        promo.innerHTML = `
          <span class="container">
            <span class="festive-promo-group">
              <span class="festive-promo-title">
                Pack of 3 scrunchies worth ₹199 <br>
                Free on all orders above ₹2000 
              </span>
            </span>
          </span>
        `;
        if ( !document.querySelector('.festive-promo-section') ) {
          product.insertAdjacentElement('afterend', promo);
        }
      }
    });
  }
  // Run once products are ready
  eleReady('body.template-collection .collection .productListing .product', (el) => {
    insertPromoBlocks();
  });
    */

let offerIndex = 0; // Global counter to track which offer to show next
eleReady('body.template-collection .collection .productListing .product', (el) => {
    const allElements = document.querySelectorAll('body.template-collection .collection .productListing .product');
    const index = Array.prototype.indexOf.call(allElements, el);

  
      if ((index + 1) % 6 === 0) {
        /*
        const offers = [
        `<span class="container">
                <span class="festive-promo-group">
                  <span class="festive-promo-title">
                    Pack of 3 scrunchies worth ₹199 <br>
                    Free on all orders above ₹2000 
                  </span>
                </span>
              </span>`,
        `<span class="container">
                <span class="festive-promo-group">
                  <span class="festive-promo-title">
                    1 Utility pouch worth ₹349 <br>
                    Free on all orders above ₹3000 
                  </span>
                </span>
              </span>`,
        `<span class="container">
                <span class="festive-promo-group">
                  <span class="festive-promo-title">
                    Pack of 4 utility bags worth ₹499 <br>
                    Free on all orders above ₹5000 
                  </span>
                </span>
              </span>`
        ];
        */

        
        const offers = [
        `<span class="container">
                <span class="festive-promo-group">
                  <span class="festive-promo-title">
                    Pack of 3 scrunchies worth ₹199 <br>
                    Free on all orders above ₹2000 
                  </span>
                </span>
              </span>`,
        `<span class="container">
                <span class="festive-promo-group">
                  <span class="festive-promo-title">
                    1 Utility pouch worth ₹349 <br>
                    Free on all orders above ₹3000 
                  </span>
                </span>
              </span>`
        ];
        
        // Pick a random offer
        const currentOffer = offers[offerIndex];
        offerIndex = (offerIndex + 1) % offers.length;
        
        const promo = document.createElement('li');
        promo.className = 'festive-promo-section';
        promo.innerHTML = currentOffer;
        el.insertAdjacentElement('afterend', promo);
      }

});







    

    /* Add multiple images */
    const collectionProductsUrl = window.location.origin + window.location.pathname + '/products.json'; // Collection page url products.json
    
    async function fetchProductData() {
      const response = await fetch(`${collectionProductsUrl}?limit=2000`);
      const data = await response.json();
      console.log('Fetched product data:', response);
      return data?.products || [];
    }
    /*
    async function applyImagesAndSlickToProducts(products, newItems) {
      newItems.forEach((item, index) => {
        if (item.classList.contains('product-initialized')) return; // Prevent double init
        item.classList.add('product-initialized');

        const imageWrapper = item.querySelector('.collection .product .card-media');
        if (!imageWrapper || !products[index]) return;

        // Create slider container
        const sliderContainer = document.createElement('div');
        sliderContainer.classList.add('product-itemimg-slider');

        // Loop product images
        products[index].images.forEach((imgObj) => {
          const imgSrc = typeof imgObj === 'string' ? imgObj : imgObj.src || imgObj.url;
          if (imgSrc) {
            const imgContainer = document.createElement('div');
            imgContainer.classList.add('product-item__image');
            imgContainer.style.width = `303px`;
            imgContainer.style.height = `auto`;

            const imgEl = document.createElement('img');

            // Modify src to inject _303x before extension
            const parts = imgSrc.split(/(\.jpg|\.jpeg|\.png|\.webp|\.gif|\.avif)/i);
            if (parts.length >= 2) {
              imgEl.src = `${parts[0]}_303x${parts[1]}${parts[2] || ''}`;
              // Optionally retina support:
              imgEl.srcset = `${parts[0]}_303x${parts[1]} 1x, ${parts[0]}_338x${parts[1]} 2x`;
              imgEl.sizes = "303px";
            } else {
              imgEl.src = imgSrc;
            }

            imgEl.alt = products[index].title || 'Product image';
            imgEl.style.width = `303px`;
            imgEl.style.height = `auto`;
            imgEl.style.display = 'block';

            imgContainer.appendChild(imgEl);
            sliderContainer.appendChild(imgContainer);
          }
        });

        imageWrapper.appendChild(sliderContainer);

        // Delay slick init by 1 seconds
        $(sliderContainer).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            autoplay: false,
            dots: true,
            infinite: true,
            arrows: false, // No arrows
        });
      });
    }
    async function init() {
      const products = await fetchProductData();

      const applyToVisibleProducts = () => {
        const allItems = Array.from(document.querySelectorAll('.productListing > .product'));
        applyImagesAndSlickToProducts(products, allItems);
      };

      // Initial render
      applyToVisibleProducts();

      // Watch for new products (infinite scroll etc.)
      const observer = new MutationObserver(() => {
        applyToVisibleProducts();
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }
    init();
    */


    /* Quick View */
    async function fetchProductHTML(slug) {
      const url = `https://mysanskritam.com/products/${slug}`;

      try {
        const res = await fetch(url, {
          method: "GET",
        });

        if (!res.ok) {
          window.location.href = `/products/${slug}`;
          return;
        }

        const html = await res.text();
        return html;
      } catch (error) {
        console.error("Error fetching HTML content:", error);
        return null;
      }
    }

    let currentSlug = null;
    document.addEventListener("click", async (e) => {
      if ( e.target.classList.contains("CP-quick-view-btn") ) {
            const modal = document.querySelector(".CP-quick-view-modal");
            modal.style.display = "block";
            modal.classList.add("cp_modal_loading");
            let productItem;
            if (e.target.closest(".product")) {
                productItem = e.target.closest(".product");
            }
            else {
                productItem = e.target.closest(".st-product-wrap");
            }

            const anchor = productItem.querySelector('a[href*="/products/"]');
            if (!anchor) return;

            const href = anchor.getAttribute("href");
            const slugMatch = href.match(/\/products\/([^/?#]+)/);
            const slug = slugMatch ? slugMatch[1] : null;

            if (!slug) return;
            currentSlug = slug;
            const productHTML = await fetchProductHTML(slug);
            const parser = new DOMParser();
            const productDoc = parser.parseFromString(productHTML, "text/html");

            const modalContent = modal.querySelector(".CP-modal-content");
            const closeBtn = modal.querySelector(".CP-close-btn");
            const mediaContainer = modalContent.querySelector(".CP-product-media");
            const detailContainer = modalContent.querySelector(".CP-product-info");
            const titleContainer = modalContent.querySelector(".CP-product-title");
            const priceContainer = modalContent.querySelector(".CP-product-price");

            mediaContainer.innerHTML = "";
            detailContainer.innerHTML = "";
            titleContainer.innerHTML = "";
            priceContainer.innerHTML = "";

            modal.style.display = "block";

            closeBtn.addEventListener("click", () => {
                modal.style.display = "none";
            });

            const productMedia = productDoc.querySelector(".productView-image-wrapper").cloneNode(true);

            const productDescTab = productDoc.querySelector(".productView-tab .tab-content#tab-description .toggle-content") || productDoc.querySelector(".custom-accordion-wrapper .accordion-item:first-child .accordion-content");
            const productDetails = productDescTab.cloneNode(true);

            const productTitle = productDoc.querySelector(".productView-title")?.cloneNode(true);

            const productPrice = productDoc.querySelector(".price-item.price-item--regular").cloneNode(true);

            mediaContainer.appendChild(productMedia);

            const swiperSlides = mediaContainer.querySelectorAll(".slick-slide");

            swiperSlides.forEach((slide) => {
                const img = slide.querySelector("img");
                if (img) {
                    const dataSrc = img.getAttribute("data-src");
                    if (dataSrc && !img.getAttribute("src")) {
                        img.setAttribute("src", dataSrc);
                        img.setAttribute("width", 767);
                        img.setAttribute("height", 500);
                    }
                }
            });

            setTimeout(() => {
                $('.CP-product-media .productView-nav').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    autoplay: false,
                    dots: true,
                    infinite: true,
                    arrows: false, // No arrows
                });
            }, 100);

            titleContainer.appendChild(productTitle);
            priceContainer.appendChild(productPrice);

            detailContainer.appendChild(productDetails);
            modal.classList.remove("cp_modal_loading");
        }

      /*
      if (e.target.classList.contains("CP-atc-btn")) {
        if (e.target.closest(".productListing .product-item")) {
          const productItem = e.target.closest(".productListing .product-item");
          const realAtcButton = productItem.querySelector(".productListing .product-item .button[data-quickshop-popup]") || productItem.querySelector(".productListing .product-item .button[data-btn-addtocart]");
          realAtcButton.click();
          
          //productItem.querySelector(".product-item").classList.add("quickshop-popup-show");
          productItem.querySelector(".card").classList.add("quickshop-popup-show");
          console.log("Clicked");
          if (window.innerWidth <= 767) {
            document.body.classList.add('quick_shop_popup_mobile');
          }

        }
      }
      */
      if (e.target.classList.contains("CP-atc-btn")) {
        const productItem = e.target.closest(".product-item");
    
        if (productItem) {
          // Trigger the real ATC or quickshop button
          const realAtcButton = productItem.querySelector('[data-quickshop-popup], [data-btn-addtocart]');
          if (realAtcButton) {
            realAtcButton.click();
          }
          // Add popup class to card if it exists
          const card = productItem.querySelector(".card");
          if (card) {
            card.classList.add("quickshop-popup-show");
          }
          // ✅ Add class to <html> tag on mobile
          if (window.innerWidth <= 767) {
            document.documentElement.classList.add('quick_shop_popup_mobile');
          }
          console.log("ATC clicked: class added to <html>");
        }
      }
      /**/
      // ✅ Handle popup close (using .closest for robust event targeting)
      if (  e.target.closest('.background-overlay, #halo-card-mobile-popup .mobile-popup-header .close-modal, #halo-cart-sidebar .halo-sidebar-close')  ) {
        document.documentElement.classList.remove('quick_shop_popup_mobile');
      }

      
  
      if (e.target.classList.contains("CP-view-details-btn")) {
        window.location.href = `/products/${currentSlug}`;
      }
    });







// slider container
function initSlickSliders() {
    $('.product-itemimg-slider').not('.slick-initialized').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        dots: true,
        infinite: true,
        arrows: false
    });
}
$(document).ready(function() {
    initSlickSliders();
});


(function () {
  function initAutoInfiniteScroll() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const btn = entry.target;
          if (!btn.classList.contains('is-loading')) {
            btn.click(); // triggers existing infinite scroll logic
            setTimeout(initSlickSliders, 500);
          }
        }
      });
    }, { threshold: 0.2 });

    // Watch for new infinite scroll buttons
    const mutationObserver = new MutationObserver(() => {
      document
        .querySelectorAll('.pagination-page-infinite .button[data-infinite-scrolling]')
        .forEach((btn) => {
          if (!btn.dataset.observed) {
            observer.observe(btn);
            btn.dataset.observed = "true"; // mark as observed
          }
        });
    });

    // Start observing DOM changes
    mutationObserver.observe(document.body, { childList: true, subtree: true });

    // Run once on page load too
    document
      .querySelectorAll('.pagination-page-infinite .button[data-infinite-scrolling]')
      .forEach((btn) => {
        if (!btn.dataset.observed) {
          observer.observe(btn);
          btn.dataset.observed = "true";
        }
      });
  }

  document.addEventListener('DOMContentLoaded', initAutoInfiniteScroll);
})();


    







  } else if (!document.body.classList.contains('CP_FESTIVE_THEME')) {
    window.requestAnimationFrame(window.CP_FESTIVE_THEME);
  }
};

window.CP_FESTIVE_THEME();
